<template>
  <div class="header width-full ls-flex-col-center">
    <div class="max-width ispc">
        <div class="flex align-center" style="padding: 0.5rem 0;">
          <div class="flex flex-column pointer" @click="$router.push({path:'/'})">
            <img src="../assets/logo.png" alt="" class="logo">
          </div>
          <div class="flex flex-between fs-18 two" style="position: relative;">
            <div v-for="item in tabList" :key="item.id" @click="selectTab(item)" @mouseenter="mouseenter1(item)" :class="{'active': selectedTab === item.id}" class="tab-item">{{ item.name }}</div>
             <!-- show1 -->
              <!-- <div  v-if="show1 == true" @mouseleave="show1 = false">
                <div class="pointer show1">
                  <div class="flex align-center show1box" :class="index != soloList.length - 1 ? 'b-b-1' : ''" v-for="item,index in soloList" :key="item.id">
                    <img v-if="tab2Id == item.id" src="../assets/start2.png" alt="" class="start2">
                    <img v-else src="../assets/start1.png" alt="" class="start1">
                    <div class="" :class="tab2Id == item.id ? 'color1 font-bold' : ''" @click="clickTab(item.id)">{{ item.name }}</div>

                  </div>

                </div>
              </div> -->

              <!-- show2 -->
              <div  v-if="show1 == true" @mouseleave="show1 = false">
                <div class="pointer show1">
                  <div class="flex align-center show1box" :class="index != soloList.length - 1 ? 'b-b-1' : ''" v-for="item,index in soloList" :key="item.id">
                    <img v-if="tab2Id == item.id" src="../assets/start2.png" alt="" class="start2">
                    <img v-else src="../assets/start1.png" alt="" class="start1">
                    <div class="" :class="tab2Id == item.id ? 'color1 font-bold' : ''" @click="clickTab(item.id)">{{ item.name }}</div>

                  </div>

                </div>
              </div>
              <!-- <div  v-if="show2 == true" @mouseleave="show2 = false">
                <div class="pointer show2">
                  <div class="flex align-center show1box" :class="index != successList.length - 1 ? 'b-b-1' : ''" v-for="item,index in successList" :key="item.id">
                    <img v-if="tab4Id == item.id" src="../assets/start2.png" alt="" class="start2">
                    <img v-else src="../assets/start1.png" alt="" class="start1">
                    <div class="" :class="tab4Id == item.id ? 'color1 font-bold' : ''" @click="clickTab4(item.id,index)">{{ item.name }}</div>

                  </div>

                </div>
              </div> -->


              <!-- show3 -->
              <div  v-if="show3 == true" @mouseleave="show3 = false">
                <div class="pointer show3">
                  <div class="flex align-center show1box" :class="index != aboutList.length - 1 ? 'b-b-1' : ''" v-for="item,index in aboutList" :key="item.id">
                    <img v-if="tab5Id == item.id" src="../assets/start2.png" alt="" class="start2">
                    <img v-else src="../assets/start1.png" alt="" class="start1">
                    <div class="" :class="tab5Id == item.id ? 'color1 font-bold' : ''" @click="clickTab5(item.id,index)">{{ item.name }}</div>

                  </div>

                </div>
              </div>
           </div>
         



          <div class="flex align-center">
            <img src="../assets/phone.png" alt="" class="phone">
            <div class="color1 fs-20 phonecall">{{ phone }}</div>
            <img src="../assets/search.png" alt="" class="search" @click="$router.push({path:'/search'})">

          </div>
        </div>
        
      </div>
    <div class="ismobile">
      <div class="mobile flex flex-between align-center" style="position: relative;"> 
        <div class="flex align-center" @click="$router.push({path:'/'})"> 
          <img src="../assets/logo.png" alt="">
        </div>
        <div>
          <img src="../assets/search.png" @click="$router.push({path:'/search'})" alt="" style="width: 22px;height: 22px;">
          <img src="../assets/more.png" alt="" style="margin-left: 10px;width: 22px;height: 22px;" @click="toggleMobileMenu" >
        </div>
      </div>

        <div v-if="isMobileMenuVisible" class="overlay" @click="toggleMobileMenu"></div>
        <div v-if="isMobileMenuVisible" class="mobileShow" >
          <div class="mobile flex flex-between align-center" style="position: relative;"> 
            <div class="flex align-center" @click="$router.push({path:'/'});isMobileMenuVisible=false"> 
              <img src="../assets/logo.png" alt="">
            </div>
            <div>
              <img src="../assets/search.png" @click="$router.push({path:'/search'})" alt="" style="width: 22px;height: 22px;">
              <img src="../assets/more.png" alt="" style="margin-left: 10px;width: 22px;height: 22px;" @click="toggleMobileMenu" >
            </div>
          </div>
          <div class="width-full">
            <div class="bg-white" style="padding: 10px 20px 20px 20px;font-size: 14px;">
              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 1;$router.push({path:'/'});isMobileMenuVisible=false" :class="selectedTab == 1 ? 'color1 font-bold' : ''" style="padding-bottom: 10px;font-size: 15px;">首页</div>
                <i v-if="selectedTab == 1" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              <!-- <div class="flex flex-between align-center" :class="selectedTab == 2 ? '' : 'b-b-1'">
                <div @click="selectedTab = 2;$router.push({path:'/allSolo'});changeTab('');isMobileMenuVisible=false" :class="selectedTab == 2 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">校园AI智能平台 </div>
                <i v-if="selectedTab == 2" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div> -->
              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 2;isMobileMenuVisible=false" :class="selectedTab == 2 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">校园AI智能平台 </div>
                <i v-if="selectedTab == 2" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              <!-- <div class="tab2Show b-b-1" v-if="selectedTab == 2">
                <div class="flex align-center" v-for="item in soloList" :key="item.id" @click="clickTab(item.id)" style="padding-bottom: 10px;">
                  <div :class="tab2Id == item.id ? 'bg-1' : 'bg-black'" style="width: 3px;height: 3px;border-radius: 50%;"></div>
                  <div :class="tab2Id == item.id ? ' color1 font-bold' : ''"  style="font-size: 12px;padding-left: 10px;">{{ item.name }}</div>

                </div>
              </div> -->


              <div class="flex flex-between align-center" :class="selectedTab == 3 ? '' : 'b-b-1'">
                <!-- /success1 -->
                <div @click="selectedTab = 3;$router.push({path:'/allSolo'});changeTab('');isMobileMenuVisible=false" :class="selectedTab == 3 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">AI场景化解决方案 </div>
                <i v-if="selectedTab == 3" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              <div class="tab2Show b-b-1" v-if="selectedTab == 3">
                <div class="flex align-center" v-for="item in soloList" :key="item.id" @click="clickTab(item.id)" style="padding-bottom: 10px;">
                  <div :class="tab2Id == item.id ? 'bg-1' : 'bg-black'" style="width: 3px;height: 3px;border-radius: 50%;"></div>
                  <div :class="tab2Id == item.id ? ' color1 font-bold' : ''"  style="font-size: 12px;padding-left: 10px;">{{ item.name }}</div>

                </div>
                <!-- <div class="flex align-center" v-for="item,index in successList" :key="item.id" @click="clickTab4(item.id,index)" style="padding-bottom: 10px;">
                  <div :class="tab4Id == item.id ? 'bg-1' : 'bg-black'" style="width: 3px;height: 3px;border-radius: 50%;"></div>
                  <div :class="tab4Id == item.id ? ' color1 font-bold' : ''"  style="font-size: 12px;padding-left: 10px;">{{ item.name }}</div>

                </div> -->
              </div>



              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 4;$router.push({path:'/service'});isMobileMenuVisible=false" :class="selectedTab == 4 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">服务咨讯 </div>
                <i v-if="selectedTab == 4" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              
              <div class="flex flex-between align-center" :class="selectedTab == 5 ? '' : 'b-b-1'">
                <div @click="selectedTab = 5;$router.push({path:'/about'});isMobileMenuVisible=false;changeTab5(aboutList[0].id);" :class="selectedTab == 5 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">未来视讯科技AI </div>
                <i v-if="selectedTab == 5" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              <div class="tab2Show b-b-1" v-if="selectedTab == 5">
                <div class="flex align-center" v-for="item,index in aboutList" :key="item.id" @click="clickTab5(item.id,index)" style="padding-bottom: 10px;">
                  <div :class="tab5Id == item.id ? 'bg-1' : 'bg-black'" style="width: 3px;height: 3px;border-radius: 50%;"></div>
                  <div :class="tab5Id == item.id ? ' color1 font-bold' : ''"  style="font-size: 12px;padding-left: 10px;">{{ item.name }}</div>

                </div>
              </div>
              
              <!-- <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 6;$router.push({path:'/contact'});isMobileMenuVisible=false" :class="selectedTab == 6 ? 'color1 font-bold' : ''"  style="padding: 10px 0;font-size: 15px;">联系我们</div>
                <i v-if="selectedTab == 6" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div> -->

              <div class="flex flex-between align-center ">
                <div @click="selectedTab = 7;$router.push({path:'/future'});isMobileMenuVisible=false" :class="selectedTab == 7 ? 'color1 font-bold' : ''"  style="padding: 10px 0;font-size: 15px;">携手未来</div>
                <i v-if="selectedTab == 7" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              
            </div>
          </div>
        </div>
      
    </div>
  </div>
  
</template>
   
<script>
import { mapState, mapActions } from 'vuex';
import { EventBus } from '../utils/eventBus'
import { jjfw_classs,config_info } from "../api/home";

export default {
  computed: {
    ...mapState(['tab2Id','tab4Id','tab5Id']),
  },
	data() {
		return { 
      tabList:[
        {id:1,name:'首页',path:'home'},
        {id:2,name:'校园AI智能平台',path:'home'},
        // {id:3,name:'AI场景化解决方案',path:'success1'},
        {id:3,name:'AI场景化解决方案',path:'allSolo'},
        {id:4,name:'服务资讯',path:'service'},
        {id:5,name:'未来视讯科技AI',path:'about'},
        // {id:6,name:'联系我们',path:'contact'},
        {id:7,name:'携手未来',path:'future'},

      ],
      selectedTab: 1,
      isMobileMenuVisible: false,
      more:'',
      show1:false,
      soloList:[],
      show2:false,
      successList:[
        {id:1,name:'视频案例'},
        {id:2,name:'图文案例'},
        {id:3,name:'设计作品'}
      ],
      aboutList:[
        {id:1,name:'关于我们'},
        {id:2,name:'荣誉资质'},
        {id:3,name:'优秀团队'},
        {id:4,name:'人才招聘'},
        {id:5,name:'联系我们'},

      ],
      show3:false,
      phone:''

		}
	},

  created(){
    this.getSoloType()
    this.getInfo()

    
  },
  watch: {
    '$route': 'setSelectedTab'
  },
  methods: {
    ...mapActions(['changeTab','changeTab4','changeTab5']),
    getInfo(){
      config_info({
        type:'lxdh'
      }).then((res) => {
        if (res.code == 1) {
          this.phone = res.data
        }
      })
    },
    getSoloType(){
      jjfw_classs({
        index_switch:''
      }).then((res) => {
        if (res.code == 1) {
         this.soloList = res.data
         this.soloId = res.data[0].id
        }
      });
    },
    setSelectedTab() {
      const path = this.$route.path.split('/')[1];
      if (path == 'allSolo' || path == 'soloDtl') {
        this.selectedTab = 3; 
      } else if (path == 'search') {
        this.selectedTab = ''; 
      }else if (path == 'success1Dtl' || path == 'success2' || path == 'success3') {
        this.selectedTab = 3; 
      }else if (path == 'serviceDtl') {
        this.selectedTab = 4; 
      }else if (path == 'rencai') {
        this.selectedTab = 5; 
      }else if (path == 'contact') {
        this.selectedTab = 5; 
      }else{
        const selected = this.tabList.find(tab => tab.path === path);
        this.selectedTab = selected ? selected.id : 1;
      }
    },
    selectTab(item) {
      this.selectedTab = item.id; 
      // if(this.selectedTab == 2){
      //   this.changeTab('');
      // }
      if(this.selectedTab == 3){
        // this.changeTab4('');
        this.changeTab('');
      }
      if(this.selectedTab == 5){
        this.changeTab5('');
      }
      console.log(item)
      this.$router.push({ path: item.path == 'home' ? '/' : `/${item.path}` });
    },
    mouseenter1(item){
      this.more = item.id
      // if(this.more == 2){
      //   this.show1 = true
      // }else{
      //   this.show1 = false
      // }
      if(this.more == 3){
        this.show1 = true
      }else{
        this.show1 = false
      }
      // if(this.more == 3){
      //   this.show2 = true
      // }else{
      //   this.show2 = false
      // }
      if(this.more == 5){
        this.show3 = true
      }else{
        this.show3 = false
      }
    },
    clickTab(id){
      this.$router.push({ path: '/soloDtl',query:{id:id}});
      this.changeTab(id);
      setTimeout(() => {
        window.location.reload()
      }, 200);
      this.isMobileMenuVisible=false
    },
    clickTab4(id,index){
      console.log(id)
      console.log(index,111)
      if(index == 0){
        this.$router.push({ path: '/success1'});
      }else if(index == 1){
        this.$router.push({ path: '/success2'});
      }else{
        this.$router.push({ path: '/success3'});
      }
      this.changeTab4(id);
      this.isMobileMenuVisible=false

    },
    clickTab5(id,index){
      if(index == 0){
        this.$router.push({ path: '/about'});
        setTimeout(()=>{
          EventBus.$emit('scrollTo', 'about'); // 触发事件
        },500)
      }else if(index == 1){
        this.$router.push({ path: '/about'});
        setTimeout(()=>{
          EventBus.$emit('scrollTo', 'honors'); // 触发事件
        },500)
      }else if(index == 2){
        this.$router.push({ path: '/about'});
        setTimeout(()=>{
          EventBus.$emit('scrollTo', 'team'); // 触发事件
        },500)
      }else if(index == 3){
        this.$router.push({ path: '/rencai'});
      }else{
        this.$router.push({ path: '/contact'});
      }
      this.changeTab5(id);
      this.isMobileMenuVisible=false

    },
    toggleMobileMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;
    },
  },
}
</script>

<style scoped lang="scss">
.start1{
  width: 13px;
  height: 13px;
  margin-right: 10px;
}
.start2{
  width: 14px;
  height: 14px;
  margin-right: 9px;
}
.show1{
  position: absolute;
  left: 230px;
  top: 50px;
  font-size: 15px;
  background: #fff;
  padding: 20px;
  .show1box{
    display: flex;              
    align-items: center;    
    justify-content: space-between;
    padding: 15px 0;           
    
  }
  .show1box > div {
    flex: 1;             
    text-align: center;     
  }
}
.show2{
  position: absolute;
  left: 270px;
  top: 50px;
  font-size: 15px;
  background: #fff;
  padding: 10px 30px;
  .show1box{
    display: flex;              
    align-items: center;    
    justify-content: space-between;
    padding: 15px 0;           
    
  }
  .show1box > div {
    flex: 1;             
    text-align: center;     
  }
}

.show3{
  position: absolute;
  left: 560px;
  top: 50px;
  font-size: 15px;
  background: #fff;
  padding: 10px 30px;
  .show1box{
    display: flex;              
    align-items: center;    
    justify-content: space-between;
    padding: 15px 0;           
    
  }
  .show1box > div {
    flex: 1;             
    text-align: center;     
  }
}
.header{
  position: sticky;
  top: 0;
  z-index: 1000 !important;
  background-image: url('https://oozstar.oss-ap-northeast-1.aliyuncs.com/index/baoxiu/headerBg.png');
  background-size: cover;
}
.tab-item {
  cursor: pointer;
  padding-bottom: 0.6rem;
  color: #fff;
  margin: 0 1.3rem;
}

.tab-item.active {
  color: #F3CF75; 
  border-bottom: 2px solid #F3CF75;
  font-weight: bold;

}
.two{
  padding-top: 0.45rem;
  margin-left: 168px;
  margin-right: 22px;
}
.logo{
  width: 105px;
  height: 75px;
}
.phone{
  width: 32px;
  height: 32px;
}
.phonecall{
  padding-left: 12px;
  padding-right: 15px;
}
.search{
  width: 22px;
  height: 22px;
  cursor: pointer;
}



.ismobile{
  width: 100%;

}
.mobile {
  padding: 0.3rem 20px;
  background-image: url('https://oozstar.oss-ap-northeast-1.aliyuncs.com/index/baoxiu/headerBg.png');
  background-size: cover;

  img {
    width: 40px;
    height: 30px;
  }
}
.mobileShow {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 1);
  z-index: 999;
  display: block;
}


@media (max-width: 1200px) {
  .header{
    background: none;
  }
  
  .ispc{
    display: none;
  }
  .mobileShow{
    position: absolute;
    top: 0;
    left: 0;
  }
  
}
@media (min-width: 1201px) {
  .ismobile {
    display: none; 
  }
}
</style>